<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ic-send-message-x1,5">
      <path
        id="Solid"
        d="M22.2081 12.2557C22.2175 11.5341 21.8265 10.8708 21.1917 10.5226L6.39779 2.39443C5.73517 2.01993 4.95406 2.06594 4.32967 2.4923C3.69384 2.92585 3.36839 3.95791 3.54613 4.70331L4.92721 10.4895C5.06899 11.0828 5.60001 11.5006 6.21093 11.498L14.4437 11.4724C14.8653 11.464 15.2072 11.8059 15.1987 12.2275C15.1975 12.6419 14.8606 12.9788 14.439 12.9872L6.19839 13.0064C5.58747 13.0075 5.05385 13.4272 4.90839 14.0214L3.47848 19.8306C3.30486 20.5171 3.5028 21.2024 3.98717 21.6868C4.04416 21.7437 4.10827 21.8079 4.17242 21.8577C4.79969 22.3416 5.6212 22.4034 6.32259 22.0296L21.1667 13.981C21.8036 13.6432 22.1987 12.9774 22.2081 12.2557Z"
        fill="#FAFAFA" />
    </g>
  </svg>
</template>
